import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "auth-layout" }
const _hoisted_2 = { class: "auth-layout__left-col" }
const _hoisted_3 = { class: "white-logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "auth-layout__right-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: require('@/assets/white-logo.svg'),
          alt: ""
        }, null, 8 /* PROPS */, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_view)
    ])
  ]))
}